import { render, staticRenderFns } from "./Pathogens.vue?vue&type=template&id=45bb44e6"
import script from "./Pathogens.vue?vue&type=script&lang=js"
export * from "./Pathogens.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports